import {
  DkimStatus,
  MailFromDomainStatus,
} from "@redotech/redo-model/email/domain-verification";
import * as z from "zod/v4";

export const getCustomDomain = {
  name: "getCustomDomain" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    domain: z.string().nullish(),
    mailFromDomain: z.string().nullish(),
    mailFromDomainStatus: z.enum(MailFromDomainStatus).nullish(),
    fromName: z.string().nullish(),
    fromEmail: z.string().nullish(),
    dkimStatus: z.enum(DkimStatus).nullish(),
    warmingEnabled: z.boolean().nullish(),
  }),
};
